import { capitalize } from '@/utils/general';
import { Box, Typography, useTheme } from '@mui/material';
import { ChevronRight } from 'lucide-react';

export const LearningExprienceItem = ({
  currentCourse,
  title,
  showIcon = true,
  opacity = false,
  icon: Icon,
  onClick,
}: {
  title: string;
  icon: React.ReactNode;
  currentCourse: string;
  showIcon?: boolean;
  opacity?: boolean;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
        py: 1.5,
        minHeight: '44px',
        cursor: onClick ? 'pointer' : 'default',
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:last-child': { borderBottom: 'none' },
        '&:active': onClick ? { opacity: 0.7 } : {},
      }}
    >
      {Icon}
      <Box
        sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}
      >
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: theme.fontSizes.body,
            fontWeight: 600,
            color: opacity
              ? theme.palette.text.secondary
              : theme.palette.text.primary,
          }}
          noWrap
        >
          {capitalize(title)}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: theme.fontSizes.caption,
            color: opacity
              ? theme.palette.text.disabled
              : theme.palette.text.secondary,
            mt: 0.25,
          }}
          noWrap
        >
          {currentCourse.toLocaleLowerCase()}
        </Typography>
      </Box>
      {showIcon && (
        <ChevronRight
          size={16}
          color={theme.palette.text.disabled}
          style={{ flexShrink: 0 }}
        />
      )}
    </Box>
  );
};
